/**
 * @file Base grid display component.
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { EventEmitter, AfterViewInit, OnInit, OnDestroy, ElementRef, NgZone, ChangeDetectorRef } from '@angular/core';
import { ControlBase } from '../../base/helpers/control-base';
import { EntityAction } from 'breeze-client';
import { DataSet } from '../../core/helpers/data-set';
import { GridBarBaseComponent } from '../grid-bar-base/grid-bar-base.component';
import * as moment from 'moment';
import { NavigationEnd } from '@angular/router';
import { RoutesService } from '../../routes.service';
import { take } from 'rxjs/internal/operators/take';
var GridDisplayBaseComponent = /** @class */ (function (_super) {
    tslib_1.__extends(GridDisplayBaseComponent, _super);
    function GridDisplayBaseComponent(router, domainService, localisationService, settingsService, backendSettingsService, overlayService, executorsService, alertsService, elementRef, ngZone, changeDetector, eventsService, gridService) {
        var _this = _super.call(this, alertsService) || this;
        _this.router = router;
        _this.domainService = domainService;
        _this.localisationService = localisationService;
        _this.settingsService = settingsService;
        _this.backendSettingsService = backendSettingsService;
        _this.overlayService = overlayService;
        _this.executorsService = executorsService;
        _this.alertsService = alertsService;
        _this.elementRef = elementRef;
        _this.ngZone = ngZone;
        _this.changeDetector = changeDetector;
        _this.eventsService = eventsService;
        _this.gridService = gridService;
        /**
         * Field holding reference to entity changed subscription.
         * This is used to update the agenda accordingly.
         * @private
         * @type {number}
         */
        _this.entityChangedSubscription = undefined;
        _this._selectedWrapper = null;
        _this.itemResizeData = undefined;
        /**
         * A value indicating whether AfterViewInit has completed.
         * @memberOf GridDisplayBaseComponent
         */
        _this.initialized = false;
        _this.selectionChanged = new EventEmitter();
        _this._objects = new DataSet();
        _this.dynamicParameters = [];
        _this.loadingInProgress = null;
        // Loading state of component
        _this.isLoading = false;
        eventsService.register('drop-successful');
        return _this;
    }
    Object.defineProperty(GridDisplayBaseComponent.prototype, "gridCollections", {
        get: function () {
            return this._gridCollections;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridDisplayBaseComponent.prototype, "expandedIndex", {
        get: function () {
            if (this.bar === null || typeof this.bar === 'undefined') {
                return null;
            }
            else {
                return this.bar.expandedIndex;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridDisplayBaseComponent.prototype, "objects", {
        get: function () {
            return this._objects;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Is called after a drop edit executor to show its first result in the detail section of the right side bar.
     * @param {Entity[]} items The results of the executor.
     */
    GridDisplayBaseComponent.prototype.showResultExecutor = function (items) {
        if (items == null || items.length === 0) {
            return;
        }
        var sorted = items.sort(function (a, b) { return a['Start'].getTime() - b['Start'].getTime(); });
        this.tryOpenDetailsOf(sorted[0], 6);
    };
    /** Is given date today. */
    GridDisplayBaseComponent.prototype.isToday = function (date) {
        return moment().isSame(date, 'd');
    };
    /**
     * Tries to show the entity in the detail section of the right side bar.
     * @protected
     * @param {Entity} item The entity to show.
     * @param {number} tries Number of tries.
     */
    GridDisplayBaseComponent.prototype.tryOpenDetailsOf = function (item, tries) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (tries === 0) {
                    return [2 /*return*/];
                }
                window.setTimeout(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var wrapper, wrapper;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!this.loadingInProgress) return [3 /*break*/, 2];
                                return [4 /*yield*/, this.loadingInProgress];
                            case 1:
                                _a.sent();
                                wrapper = this.findWrapperOf(item);
                                if (wrapper) {
                                    this.selectPlanItem(wrapper);
                                }
                                else {
                                    this.tryOpenDetailsOf(item, tries - 1);
                                }
                                return [3 /*break*/, 3];
                            case 2:
                                wrapper = this.findWrapperOf(item);
                                if (wrapper) {
                                    this.selectPlanItem(wrapper);
                                }
                                else {
                                    this.tryOpenDetailsOf(item, tries - 1);
                                }
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); }, 500);
                return [2 /*return*/];
            });
        });
    };
    /**
     * Finds the wrapper of the given entity.
     * @protected
     * @param {Entity} item The entity to look for.
     * @returns {PlanItemWrapper} The wrapper when found otherwise null.
     */
    GridDisplayBaseComponent.prototype.findWrapperOf = function (item) {
        if (item == null) {
            return null;
        }
        var resourceOid = item['Resource_Oid'];
        // Reduce the search space
        var gridSegments;
        if (this._gridCollections && this._gridCollections.length === 1) {
            gridSegments = this._gridCollections[0];
        }
        else {
            gridSegments = this._gridCollections.find(function (it) {
                return (it.meta && it.meta.resource && it.meta.resource.Oid === resourceOid);
            });
        }
        if (gridSegments == null) {
            return;
        }
        var itemOid = item['Oid'];
        var search;
        switch (item.entityType.shortName) {
            case 'Appointment':
                search = function (col) { return col.gridAbsences.map(function (it) { return it; }).find(function (it) { return it.item.Item_Oid === itemOid; }); };
                break;
            case 'Assignment':
                if (item['Appointment']) {
                    search = function (col) { return col.gridAppointments.map(function (it) { return it; }).find(function (it) { return it.item.Item_Oid === itemOid; }); };
                }
                else {
                    search = function (col) { return col.gridAssignments.map(function (it) { return it; }).find(function (it) { return it.item.Item_Oid === itemOid; }); };
                }
                break;
            case 'Attendant':
                search = function (col) { return col.gridAttendants.map(function (it) { return it; }).find(function (it) { return it.item.Item_Oid === itemOid; }); };
                break;
        }
        for (var _i = 0, _a = gridSegments.children; _i < _a.length; _i++) {
            var a = _a[_i];
            for (var _b = 0, _c = a.children; _b < _c.length; _b++) {
                var b = _c[_b];
                for (var _d = 0, _e = b.children; _d < _e.length; _d++) {
                    var c = _e[_d];
                    var test = search(c);
                    if (test != null) {
                        return test;
                    }
                }
            }
        }
        return null;
    };
    /**
     * Lifecycle hook that is called after a component's view has been fully initialized.
     */
    GridDisplayBaseComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.initialLoading();
        this.subscriptionPool.add(this.router.events.subscribe(function (event) {
            if (event instanceof NavigationEnd) {
                _this.refreshIfNeeded();
                if (RoutesService.getDetailId(_this.router.routerState) == null) {
                    _this.selectPlanItem(null);
                }
            }
        }));
        // The dragover event is needed to make a drop work. The problem is that for every move the draggable
        // item fires the dragover event of Angular and a change detection is handled.  This is per pixel (!)
        // so it's quite slow to 're-render' the grid. Therefore I placed the dragover event outside Angular via NgZone.
        // This construction is used in grid-display-base.component.ts, grid-drag-base.component.ts, plugin-view-shifts and grid-bar-base.component.ts.
        this.ngZone.runOutsideAngular(function () {
            _this.elementRef.nativeElement.addEventListener('dragover', function (dragEvent) {
                dragEvent.stopPropagation();
                dragEvent.preventDefault();
            });
            _this.elementRef.nativeElement.addEventListener('drop', function (dragEvent) {
                dragEvent.stopPropagation();
                dragEvent.preventDefault();
            });
        });
    };
    /**
     * Callback when pagination is destroyed to cleanup references.
     */
    GridDisplayBaseComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.domainService.entityManager.entityChanged.unsubscribe(this.entityChangedSubscription);
    };
    /**
     * Is called right after the directive's data-bound properties have been checked for the
     * first time, and before any of its children have been checked. It is invoked only once when the
     * directive is instantiated.
     */
    GridDisplayBaseComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.entityChangedSubscription != null) {
            this.domainService.entityManager.entityChanged.unsubscribe(this.entityChangedSubscription);
        }
        this.entityChangedSubscription = this.domainService.entityManager.entityChanged.subscribe(function (args) {
            var entityName = args.entity.entityType.shortName;
            if (!(entityName === 'PlanItem' || entityName === 'Appointment' || entityName === 'Assignment' || entityName === 'Attendant')) {
                return;
            }
            if (
            // Na opslaan verandert entity state van modified naar unchanged.
            (args.entityAction === EntityAction.EntityStateChange && args.entity.entityAspect.entityState.isUnchanged()) ||
                // Als een item verwijdert wordt.
                args.entityAction === EntityAction.Detach || args.entityAction === EntityAction.MergeOnSave) {
                _this.refreshFor(args.entity);
            }
            // In geval als Draft flag door server is terug gezet
            if (entityName === 'Appointment' && args.entityAction === EntityAction.MergeOnSave) {
                _this.domainService.getEntityByKey(args.entity.entityType, args.entity['Oid'], false);
            }
        });
    };
    /**
     * Select plan item by user (thus via the interface)
     * @param {PlanItemWrapper} item
     * @returns
     */
    GridDisplayBaseComponent.prototype.selectPlanItemByUser = function (item) {
        // Check if plan item just is resized
        if (this.isPlanItemJustResized(item)) {
            return;
        }
        this.selectPlanItem(item);
    };
    /**
     * Select the plan item in the grid
     * @param {PlanItemWrapper} item
     * @returns
     */
    GridDisplayBaseComponent.prototype.selectPlanItem = function (item) {
        if (this.inResizeMode()) {
            return;
        }
        if (this.domainService.savingInProgress) {
            this.alertsService.createAlert('info', 'APP.GRIDS.PLEASE_WAIT');
            return;
        }
        // When unselecting then
        if (item === null) {
            if (this._selectedWrapper === null) {
                return;
            }
            this._selectedWrapper = null;
            this.selectionChanged.emit(null);
            return;
        }
        // When selecting then
        if (!this.isEntitySelected(item)) {
            this._selectedWrapper = item;
            this.selectionChanged.emit(item.item);
        }
    };
    /**
     * Check if given entity is selected
     * @param {PlanItemWrapper} item
     * @returns
     */
    GridDisplayBaseComponent.prototype.isEntitySelected = function (item) {
        if (!item || !this._selectedWrapper) {
            return false;
        }
        if (item.item === this._selectedWrapper.item) {
            return true;
        }
        if (item.item.Item_Oid !== this._selectedWrapper.item.Item_Oid) {
            return false;
        }
        if (item.item.Start.getTime() === this._selectedWrapper.item.Start.getTime()) {
            // Zelfde start dus gelijk ook bij een repeat pattern.
            return true;
        }
        return false;
    };
    /**
     * Retrieves a new fresh data set form the backend when query parameters are changed.
     * @param {Boolean} [forcing=false] Refresh is forced when true otherwise only when query parameters are changed.
     * @returns An observable of the needed retrieve request otherwise null.
     */
    GridDisplayBaseComponent.prototype.refresh = function (forcing) {
        if (forcing === void 0) { forcing = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, null];
            });
        });
    };
    Object.defineProperty(GridDisplayBaseComponent.prototype, "visibleHourStart", {
        /**
         * The visible hours (start)
         * @readonly
         * @type {number}
         */
        get: function () {
            return this.gridService.visibleHoursStart;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridDisplayBaseComponent.prototype, "visibleHoursEnd", {
        /**
         * The visible hours (finish)
         * @readonly
         * @type {number}
         */
        get: function () {
            return this.gridService.visibleHoursEnd;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridDisplayBaseComponent.prototype, "visibleDays", {
        /**
         * The visible days from the horizon
         * @readonly
         * @type {Number[]}
         */
        get: function () {
            return this.gridService.visibleDays;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridDisplayBaseComponent.prototype, "zoom", {
        /**
         * The current zoom
         * @readonly
         * @type {number}
         */
        get: function () {
            return this.gridService.zoom;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Collect the actions from the configuration (of the parent Grid)
     * @returns ActionConfiguration[] An array with the actions
     */
    GridDisplayBaseComponent.prototype.getActions = function () {
        if (!this.configuration || !this.configuration.actions) {
            return undefined;
        }
        return this.configuration.actions;
    };
    /**
     * Starts a component in the overlay depicting this action.
     * @param {ActionConfiguration} action The configuration of this action.
     * @param {GridColumn} gridColumn The grid column (timeslot) where the action is initiated
     */
    GridDisplayBaseComponent.prototype.invokeAction = function (action, gridColumn) {
        var _this = this;
        this.subscriptionPool.add(this.overlayService.createOverlay({
            action: action,
            gridColumn: gridColumn
        })
            .pipe(take(1))
            .subscribe(function (item) {
            if (!item) {
                return;
            }
            // Set the name of the executor based on the entity type of the returned item
            var executorName;
            switch (item.entityType.shortName) {
                case 'TaskTemplate':
                    executorName = 'task-adhoc';
                    break;
                case 'ShiftTemplate':
                    executorName = 'shift-adhoc';
                    break;
                case 'Absence':
                    executorName = 'absence-adhoc';
                    break;
            }
            // Execute
            _this.executorsService.initiate(executorName, {
                items: [item],
                targets: [{
                        start: gridColumn.meta.start,
                        finish: gridColumn.meta.finish
                    }],
                resources: [gridColumn.meta.resource]
            }).then(function (_a) {
                var items = _a[0], successMessage = _a[1];
                // The executor succeeded
                _this.alertsService.createAlert('success', successMessage);
                _this.refreshWith(items);
            }).catch(function (error) {
                // Something went wrong
                if (error.entityErrors && error.entityErrors.length > 0) {
                    // Error alert already created by executor.
                    return;
                }
                _this.alertsService.createAlert('danger', (typeof error === 'string') ? error : 'APP.EXECUTORS.EXECUTION_FAILED', (typeof error === 'string') ? undefined : error);
            });
        }));
    };
    /**
     * Gets a description of the publish stage of a GridColumn.
     * Is used in the template to depicts the publish stage of the planning.
     * @param {GridColumn} segment The GridColumn evaluated.
     * @returns {string} A string describing the publish stage of a GridColumn.
     */
    GridDisplayBaseComponent.prototype.getStageOf = function (segment) {
        if (segment.meta.start.isBefore(this.backendSettingsService.publishedTill)) {
            return 'publicated';
        }
        return 'unpublicated';
    };
    /**
     * Round to nearest hours and minutes based on given resolution
     *
     * @param {number} minutes The raw minutes
     * @returns { hours: number, minutes: number } The rounded hours and mintues
     */
    GridDisplayBaseComponent.prototype.roundToHoursAndMinutes = function (minutes, resolution) {
        return {
            hours: (minutes > 0) ? Math.floor((minutes / 60)) : Math.ceil((minutes / 60)),
            minutes: Math.round((minutes % 60) / resolution) * resolution
        };
    };
    // Run through the DOM tree to find the timeslot (is element with class 'sym-column')
    GridDisplayBaseComponent.prototype.findTimeslot = function (target) {
        var timeslotTarget = target;
        var howDeepInDom = 0;
        while (howDeepInDom < 4 && !timeslotTarget.classList.contains('sym-column')) {
            timeslotTarget = timeslotTarget.parentElement;
            howDeepInDom++;
        }
        if (!timeslotTarget.classList.contains('sym-column')) {
            this.alertsService.createAlert('danger', 'APP.EXECUTORS.EXECUTION_FAILED', new Error('Can not find the correct target (=sym-column) for the drag or drop'));
            return;
        }
        return timeslotTarget;
    };
    /**
     * Handling the drop event
     *
     * @param {DragEvent} event The mouse event
     * @param {ExecutorData} data The drop data
     */
    GridDisplayBaseComponent.prototype.dropItem = function (event, data) {
        var _this = this;
        // Prevent the default handling of the element
        event.stopPropagation();
        event.preventDefault();
        // Set the drop component
        data.dropComponent = this;
        // Get the executor id from the drag data
        var executorId = event.dataTransfer.getData('Text');
        // Use the executor id to find the executor event
        var executorEvent = this.executorsService.getExecutorEventById(executorId);
        // Merge executor data drag (often from the dropbar) and executor data drop (often a timeslot)
        var mergedData = Object.assign(executorEvent.data, data);
        // Get the executor
        this.executorsService.getExecutorByName(executorEvent.executorName).then(function (executor) {
            // If action is moved we have support for 'exact' positionering
            if (executor.exactPositioning && mergedData.targets && mergedData.targets.length > 0) {
                _this.modifyTimeslotsBasedDropX(mergedData, event, mergedData['offsetX']);
            }
            // Execute the executor
            return executor.execute(mergedData).then(function (_a) {
                var items = _a[0], successMessage = _a[1];
                // Execution is successful
                _this.alertsService.createAlert('success', successMessage);
                _this.refreshWith(items);
                _this.detectChanges();
                _this.eventsService.register('drop-successful').emit(true);
            });
        }).catch(function (error) {
            // Something went wrong
            if (error.entityErrors && error.entityErrors.length > 0) {
                // Error alert already created by executor.
                return;
            }
            _this.alertsService.createAlert('danger', (typeof error === 'string') ? error : 'APP.EXECUTORS.EXECUTION_FAILED', (typeof error === 'string') ? undefined : error);
        });
    };
    /**
     * Modify the timeslots based on mouse x coordinates and with respect to size (pixels and minutes)
     * of the timeslot visible in both agenda en planboard.
     * @param {ExecutorTimeslot} target The target timeslot
     * @param {DragEvent} dragEvent The mouse event
     * @param {offsetX} offsetX The offset X in pixels
     */
    GridDisplayBaseComponent.prototype.modifyTimeslotsBasedDropX = function (data, dragEvent, offsetX) {
        var _this = this;
        // const targets = data.targets.filter(item => item.start.isSameOrAfter(data.source.start) && item.start.isBefore(data.source.finish));
        data.targets.forEach(function (target) {
            _this.modifyTimeslotBasedDropX(data, target, dragEvent, offsetX);
        });
    };
    /**
     * Modify the timeslot based on mouse x coordinates and with respect to size (pixels and minutes)
     * of the timeslot visible in both agenda en planboard.
     * @param {ExecutorTimeslot} target The target timeslot
     * @param {DragEvent} dragEvent The mouse event
     * @param {offsetX} offsetX The offset X in pixels
     */
    GridDisplayBaseComponent.prototype.modifyTimeslotBasedDropX = function (data, target, dragEvent, offsetX) {
        // Only proceed if target is of type Element
        if (dragEvent.target instanceof Element) {
            var timeslotTarget = this.findTimeslot(dragEvent.target);
            if (timeslotTarget) {
                // An item can overlap several timeslots. The user can drag the first part of the item (in the first timeslot)
                // or he drags the item out of the other timeslots. The first part is called the head and the rest is called the tail.
                var entityStart = moment(data.items[0]['Start']);
                var isHead = (!data.source || (entityStart.date() === data.source.start.date() && entityStart.month() === data.source.start.month() && entityStart.year() === data.source.start.year()));
                var timeslotLeft = timeslotTarget.getBoundingClientRect().left;
                var dropitemLeft = (offsetX) ? dragEvent.clientX - offsetX : dragEvent.clientX;
                var dropPositionInPixels = dropitemLeft - timeslotLeft;
                var timeslotWidthInPixels = timeslotTarget.clientWidth;
                var timeslotWidthInMinutes = target.finish.diff(target.start, 'minutes');
                var dropPositionInTotalMinutes = (dropPositionInPixels / timeslotWidthInPixels) * timeslotWidthInMinutes;
                var roundedTime = this.roundToHoursAndMinutes(dropPositionInTotalMinutes, 15);
                var newStart = this.addHoursWithRespectToOfficeHours(target.start, roundedTime.hours, roundedTime.minutes);
                // Check #2491
                if (newStart.isBetween(this.gridService.startDate, this.gridService.endDate, 'day', '[]')) {
                    if (isHead) {
                        target.start = newStart;
                    }
                    else {
                        // If tail only change the resource, so set the date back to initial start
                        target.start.year(entityStart.year()).month(entityStart.month()).date(entityStart.date());
                    }
                }
            }
        }
    };
    /**
     * Handling the drag start event
     * @param {DragEvent} event The drag event
     * @param {string} executerName The name of the executor
     * @param {ExecutorData} data The data of the executor
     */
    GridDisplayBaseComponent.prototype.dragItem = function (dragEvent, executerName, data) {
        if (dragEvent.target instanceof Element) {
            var clientRect = dragEvent.target.getClientRects()[0];
            data['offsetX'] = Math.round(dragEvent.clientX - clientRect.left);
            // Create executor event and get the id returned
            var executorId = this.executorsService.createExecutorEventAndGetTheId(executerName, data);
            // Set the executor id
            /* Fix issue: Xerius: Bij aanlog via IE is het niet mogelijk om Afwezigheden /Services te droppen op Planbord #2718
            * Oplossing gebruik alleen 'Text' bij dataTransfer.
            * Zie: https://stackoverflow.com/questions/26213011/html5-dragdrop-issue-in-internet-explorer-datatransfer-property-access-not-pos
            */
            dragEvent.dataTransfer.setData('Text', executorId);
        }
    };
    /**
     * Handling the start resize event
     * @param {DragEvent} event The drag event
     * @param {ResizeMode} mode The drop mode
     * @param {PlanItemWrapper} planItemWrapper The wrapper of resized Entity
     * @param {GridColumn} gridColumn The timeslot
     * @param {ExecutorName} executorName The name of the executor
     */
    GridDisplayBaseComponent.prototype.startResize = function (event, mode, planItemWrapper, gridColumn, executorName) {
        // Only proceed if target is of type Element
        if (event.target instanceof Element) {
            // Prevent the default handling of the element
            event.stopPropagation();
            event.preventDefault();
            // Set the resize mode
            this.itemResizeData = {
                mode: mode,
                executorName: executorName,
                startX: event.clientX,
                planItemWrapper: planItemWrapper,
                // Not the target (= resize element), not the parent (active helper), not the grantparent (= plan item) but the grantgrantparent (=timeslot)
                timeslotWidthInPixes: event.target.parentElement.parentElement.parentElement.clientWidth,
                timeslotWidthInMinutes: gridColumn.meta.finish.diff(gridColumn.meta.start, 'minutes')
            };
        }
    };
    /**
     * Check if the grid is in resize model (resizing a plan-item)
     * @returns {boolean}
     */
    GridDisplayBaseComponent.prototype.inResizeMode = function () {
        return (this.itemResizeData !== undefined);
    };
    /**
     * Is given plan item wrapper resized by the user
     * @param {PlanItemWrapper} planItemWrapper
     * @returns {boolean}
     */
    GridDisplayBaseComponent.prototype.isPlanItemWrapperInResize = function (planItemWrapper) {
        if (!this.itemResizeData) {
            return false;
        }
        return (this.itemResizeData.planItemWrapper === planItemWrapper);
    };
    /**
     * Set the last plan item wrapper as resized
     * @param {PlanItemWrapper} planItemWrapper
     */
    GridDisplayBaseComponent.prototype.setPlanItemWrapperAsResized = function (planItemWrapper) {
        this.itemJustResizedData = {
            planItemWrapper: planItemWrapper,
            initiated: moment()
        };
    };
    /**
     * Check if given plan item is **just** resized
     * @param {PlanItemWrapper} planItemWrapper
     * @returns
     */
    GridDisplayBaseComponent.prototype.isPlanItemJustResized = function (planItemWrapper) {
        if (!this.itemJustResizedData) {
            return false;
        }
        if (this.itemJustResizedData.planItemWrapper !== planItemWrapper) {
            return false;
        }
        var millisecondsAgo = moment().diff(this.itemJustResizedData.initiated);
        return (millisecondsAgo < 200);
    };
    /**
     * Start resizing the start (left side of plan-item)
     * @param {PlanItemWrapper} planItemWrapper
     * @returns {string}
     */
    GridDisplayBaseComponent.prototype.resizeLeft = function (planItemWrapper) {
        if (!this.itemResizeData || this.itemResizeData.mode !== 'start' || this.itemResizeData.planItemWrapper !== planItemWrapper || !this.itemResizeData.distanceInPixelsNormalized) {
            return;
        }
        return this.itemResizeData.distanceInPixelsNormalized + 'px';
    };
    /**
     * Start resizing the finish (right side of plan-item)
     * @param {PlanItemWrapper} planItemWrapper
     * @returns {string}
     */
    GridDisplayBaseComponent.prototype.resizeRight = function (planItemWrapper) {
        if (!this.itemResizeData || this.itemResizeData.mode !== 'finish' || this.itemResizeData.planItemWrapper !== planItemWrapper || !this.itemResizeData.distanceInPixelsNormalized) {
            return;
        }
        return -this.itemResizeData.distanceInPixelsNormalized + 'px';
    };
    /**
     * When the office hours are visible in the grid it means that there are gaps between
     * the timeslots. If a user resizes a plan-item before or after the current timeslot
     * we need to make sure to add the hours together with the hours used in the gaps to
     * make sure that the new start and finish is placed correctly. Hours can be both positive
     * and negative!
     *
     * @param {moment.Moment} date The date
     * @param {number} hours The hours
     * @param {number} minutes The minutes
     * @returns {moment.Moments} The modified date with respect to office hours
     */
    GridDisplayBaseComponent.prototype.addHoursWithRespectToOfficeHours = function (date, hours, minutes) {
        var modifiedDate = date.clone();
        // If no office hours are visible there is no gap between timeslots. Therefore,
        // adding hours (even negative hours) is easy.
        if (!this.gridService.officeHours) {
            modifiedDate.add(hours, 'hours');
            modifiedDate.add(minutes, 'minutes');
            return modifiedDate;
        }
        var forward = (hours > 0); // Forward is adding, backwarch is removing
        var counter = Math.abs(hours);
        // Adding/removing hours one by one
        while (counter > 0) {
            // Add or remove one hour based on if the original hours
            // is positive or negative.
            if (forward) {
                modifiedDate.add(1, 'hours');
            }
            else {
                modifiedDate.subtract(1, 'hours');
            }
            // Only count the hours that are visible in the grid. (And ignore the hours that are hidden
            // in the gaps between timeslots)
            if (modifiedDate.hours() < this.visibleHoursEnd && modifiedDate.hours() >= this.visibleHourStart) {
                counter--;
            }
        }
        // Add the minutes
        modifiedDate.add(minutes, 'minutes');
        return modifiedDate;
    };
    /**
     * Handling the stop resize event
     * @param {MouseEvent} event
     * @returns
     */
    GridDisplayBaseComponent.prototype.stopResize = function (event) {
        var _this = this;
        // Prevent the default handling of the element
        event.stopPropagation();
        event.preventDefault();
        // If there is no resize data you can't stop resizing!
        if (!this.itemResizeData) {
            return;
        }
        // Get the current
        var start = moment(this.itemResizeData.planItemWrapper['entity']['Start']);
        var finish = moment(this.itemResizeData.planItemWrapper['entity']['Finish']);
        // The difference in hours and minutes based on pixels/percentages etc.
        var roundedTime = this.roundToHoursAndMinutes(this.itemResizeData['distanceInMinutes'], 15);
        // Change the start (left side of plan items is resized)
        if (this.itemResizeData.mode === 'start') {
            start = this.addHoursWithRespectToOfficeHours(start, roundedTime.hours, roundedTime.minutes);
        }
        // Change the finish (right side of plan items is resized)
        if (this.itemResizeData.mode === 'finish') {
            finish = this.addHoursWithRespectToOfficeHours(finish, roundedTime.hours, roundedTime.minutes);
        }
        // Execute the resize executor
        this.executorsService.initiate(this.itemResizeData.executorName, { items: [this.itemResizeData.planItemWrapper['entity']], targets: [{ start: start, finish: finish }] }).then(function (_a) {
            var items = _a[0], successMessage = _a[1];
            // Execution is successful
            _this.alertsService.createAlert('success', successMessage);
            _this.refreshWith(items);
        }).catch(function (error) {
            // Something went wrong
            if (error.entityErrors && error.entityErrors.length > 0) {
                // Error alert already created by executor.
                return;
            }
            _this.alertsService.createAlert('danger', 'APP.EXECUTORS.EXECUTION_FAILED', error);
        });
        // Set the resized plan item wrapper
        this.setPlanItemWrapperAsResized(this.itemResizeData.planItemWrapper);
        // Stop the current resize mode
        this.itemResizeData = undefined;
    };
    /**
     * Handling the move resize event
     * @param {MouseEvent} event
     */
    GridDisplayBaseComponent.prototype.moveResize = function (event) {
        // If there is no resize data you can't move during resize!
        if (!this.itemResizeData) {
            return;
        }
        // Set current position of mouse
        this.itemResizeData['endX'] = event.clientX;
        // Calculate the distance between start and current position of mouse
        this.itemResizeData['distanceInPixels'] = this.itemResizeData['endX'] - this.itemResizeData['startX'];
        // Calculate the distance in minutes
        this.itemResizeData['distanceInMinutes'] = (this.itemResizeData['distanceInPixels'] / this.itemResizeData['timeslotWidthInPixes']) * this.itemResizeData['timeslotWidthInMinutes'];
        // Calculate the distances but normalized
        this.itemResizeData['distanceInMinutesNormalized'] = Math.round((this.itemResizeData['distanceInMinutes']) / 15) * 15;
        // Calculate the distance in minutes but normalized
        this.itemResizeData['distanceInPixelsNormalized'] = (this.itemResizeData['distanceInMinutesNormalized'] / this.itemResizeData['distanceInMinutes']) * this.itemResizeData['distanceInPixels'];
    };
    /**
     * Handling the cancel resize event
     * @param {MouseEvent} event
     */
    GridDisplayBaseComponent.prototype.cancelResize = function (event) {
        // If there is no resize data you can't cancel the resize!
        if (!this.itemResizeData) {
            return;
        }
        // Stop the current resize mode
        this.itemResizeData = undefined;
    };
    Object.defineProperty(GridDisplayBaseComponent.prototype, "horizonDate", {
        get: function () {
            return moment.isMoment(this.gridService.date) ? this.gridService.date : moment(this.gridService.date);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridDisplayBaseComponent.prototype, "horizonLevelName", {
        get: function () {
            return this.gridService.level.name;
        },
        enumerable: true,
        configurable: true
    });
    GridDisplayBaseComponent.prototype.setHorizon = function (state) {
        this.gridService.setHorizon(state);
    };
    /**
     * Is called when the url has changed. Overridden this method to refresh display when needed.
     * @protected
     */
    GridDisplayBaseComponent.prototype.refreshIfNeeded = function () {
    };
    /**
     * Is called when a displayed entity is changed and a partial refresh is probably needed.
     * @param {Entity} entity The changed displayed entity.
     * @param {boolean} selectable Flag indicating whether or not to select the entity when needed.
     */
    GridDisplayBaseComponent.prototype.refreshFor = function (entity, selectable) {
        if (selectable === void 0) { selectable = true; }
        // Does something specific in AgendaGridDisplayComponent and in PlanboardGridDisplayComponent.
    };
    /**
     * Refresh with entity set. Refreshes only once per resource.
     * @param {Entity[]} items The entity set.
     */
    GridDisplayBaseComponent.prototype.refreshWith = function (items) {
        if (items == null || items.length === 0) {
            return;
        }
        if (items.length === 1) {
            this.refreshFor(items[0], true);
            return;
        }
        var entities = items.slice();
        var _loop_1 = function () {
            var resourceOid = entities[0]['Resource_Oid'];
            var set = entities.filter(function (it) { return it['Resource_Oid'] === resourceOid; }).sort(function (a, b) { return a['Start'].getTime() - b['Start'].getTime(); });
            this_1.refreshFor(set[0], true);
            entities = entities.filter(function (it) { return it['Resource_Oid'] !== resourceOid; });
        };
        var this_1 = this;
        while (entities.length !== 0) {
            _loop_1();
        }
    };
    /**
     * Override and use this method to load items for first time after creation of component.
     * The method should wait for all the data needed to load items before loading.
     * @protected
     * @returns {boolean} True when items are loaded otherwise false.
     */
    GridDisplayBaseComponent.prototype.initialLoading = function () {
        if (this._objects.entityType == null) {
            return false;
        }
        this.refresh();
        return true;
    };
    /**
     * Gets oid of detail url
     * @protected
     * @param {string} url The detail url.
     * @returns {string} The oid of the shown entity.
     */
    GridDisplayBaseComponent.prototype.oidOfDetailUrl = function (url) {
        var segments = url.split('/');
        return segments[segments.length - 1].split('_')[0];
    };
    /**
     * Override this method for Planboard- and AgendaGridDisplayComponent
     * @protected
     * @returns {GridCollections} Collection of grid elements
     */
    GridDisplayBaseComponent.prototype.generateGridSegments = function () {
        // If horizon does not exist; return an empty set
        return undefined;
    };
    /**
     * Used to improve the performances of the grid by introducing
     * an unique identifier per plan item.
     * @param {number} index The index number
     * @param {Entity} item The item for given row
     * @returns {String} The unique identifier
     */
    GridDisplayBaseComponent.prototype.trackByPlanItem = function (index, item) {
        return (item['Entity'] && item['Entity']['Oid']) ? item['Entity']['Oid'] : index;
    };
    /**
     * Safe way to detect changes?
     * We want to avoid the exception: ViewDestroyedError: Attempt to use a destroyed view: detectChanges
     * @protected
     * @memberOf GridDisplayBaseComponent
     */
    GridDisplayBaseComponent.prototype.detectChanges = function () {
        if (this.changeDetector.destroyed) {
            return;
        }
        this.changeDetector.detectChanges();
    };
    return GridDisplayBaseComponent;
}(ControlBase));
export { GridDisplayBaseComponent };
